import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import * as z from "zod";

// login with email and password NEXT_PUBLIC_API_URL/auth/login POST endpoint (not graphql) that creates a session

export const loginSchema = z.object({
  username: z.string().email("Please enter a valid email address"),
  password: z.string().min(1)
});
export type LoginSuccessData = {
  accessToken?: string;
};
export type LoginRequestResult = {
  ok: true;
  data: LoginSuccessData;
} | {
  ok: false;
  statusCode: number;
  error: {
    message?: string;
    statusCode: number;
  };
};
export async function requestLogin(data: z.infer<typeof loginSchema>): Promise<LoginRequestResult> {
  const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      username: data.username,
      password: data.password
    }),
    credentials: "include"
  });
  if (!response.ok) {
    const error = (await response.json()) as {
      message?: string;
      statusCode?: number;
    };
    const statusCode = typeof error.statusCode === "number" ? error.statusCode : response.status;
    return {
      ok: false,
      statusCode,
      error: {
        ...error,
        statusCode
      }
    };
  }
  const responseData = (await response.json()) as LoginSuccessData;
  return {
    ok: true,
    data: responseData
  };
}
export function useLogin(onSuccess, onError) {
  const $ = _c(3);
  let t0;
  if ($[0] !== onError || $[1] !== onSuccess) {
    t0 = {
      mutationFn: async data => {
        const result = await requestLogin(data);
        if (!result.ok) {
          onError?.(result.error);
          return;
        }
        onSuccess?.(result.data);
        return result.data;
      }
    };
    $[0] = onError;
    $[1] = onSuccess;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const loginMutation = useMutation(t0);
  return loginMutation;
}